<!--Must register Google Maps with Visa Card & create mapId and API_KEY in index.html-->
<div class="parent-container">
  <google-map [height]="height" width="100%" lat lng [center]="center" [zoom]="zoom" [options]="options" (mapClick)="onMapClick($event)">
    <map-marker *ngFor="let marker of markers" [position]="marker.position ?? { lat: 0, lng: 0 }"></map-marker>
  </google-map>
</div>